
import React, { useState } from "react";
import { Link } from "react-router-dom";
import SRList from "../component/List";
import AkkhorLayout from "../layout/akkhor";

export default function DanhSachSticker() {
  const [params, setParam] = useState();
  const [email, setEmail] = useState('');
  const [filterShow, setFilterShow] = useState(false)

  const handleSubmit = (e) => {
    e.preventDefault();
    let _param = ''
    if (email !== '') _param += "&title=" + email
    setParam(_param);
  };
  let columns = [
    { name: "id", label: "ID" },
    { name: "title", label: "Tên Sticker" },
    {
      name: "url", label: "Hình ảnh",
      options: {
        filter: false, sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          if (value && Array.isArray(value)) {
            return value.map((item, i) => 
              <img src={item} style={{ width: 100 }} key={i}/>
            )
          }
          return null
        },
      }
    },
    { name: "status", label: "Trạng thái" },
  ];


  return (<AkkhorLayout idrole="quan-ly-sticker">
    <div className="breadcrumbs-area">
      <ul>
        <li>
          <Link to="/">Trang chủ</Link>
        </li>

        <li>Danh sách phòng ban</li>
      </ul>
    </div>
    <div className="card mb-3">
      <div className="card-header">
        <div className="d-flex">
          <div className="mr-auto">
            <h3 className="title">Tìm kiếm</h3>
          </div>
          <button className="btn btn-sm btn-defaul" onClick={() => setFilterShow(!filterShow)}><span className={!filterShow ? "fas fa-angle-down" : "fas fa-angle-up"}></span></button>
        </div>
      </div>
      <div className={filterShow ? "card-body" : 'hidden-filter'}>
        <form className="new-added-form" method="get" >
          <div className="row">
            <div className="col-lg-3 col-md-6 col-sm-6 col-12 form-group">
              <label>Tên sticker </label>
              <input type="text" placeholder="Tìm theo tên sticker" value={email} onChange={(e) => setEmail(e.target.value)} multiple className="form-control height32" autoComplete="off" />
            </div>

            <div className="col-12 ">
              <button type="submit" onClick={handleSubmit} className="btn-fill-sm btn-gradient-yellow btn-hover-bluedark">Lọc</button>
            </div>
          </div>
        </form>
      </div>
    </div>
    <SRList name="posts_sticker" idrole="quan-ly-sticker" params={params} title="Danh sách sticker" defaultLimit={50} serverSide={true} columns={columns}>

    </SRList>
  </AkkhorLayout>);
}
